import { createStore } from '@xstate/store';

type PopupState = {
  boardContextMenu: { x: number; y: number; date: string; column: string } | null;
  taskContextMenu: { taskId: string; x: number; y: number; dayOffset: number } | null;
  assigneePicker: { taskId: string; x: number; y: number } | null;
  columnContextMenu: { x: number; y: number; column: string } | null;
  addTaskRequest: { column: string; date: string } | null;
  editColumnRequest: { column: string; x: number; y: number } | null;
  deleteColumnRequest: { column: string } | null;
  taskPoolRequest: { column?: string } | null;
  editTaskRequest: { taskId: string } | null;
};

export const popupStore = createStore({
  context: {
    boardContextMenu: null,
    taskContextMenu: null,
    assigneePicker: null,
    columnContextMenu: null,
    addTaskRequest: null,
    editColumnRequest: null,
    deleteColumnRequest: null,
    taskPoolRequest: null,
    editTaskRequest: null,
  } as PopupState,
  on: {
    'popup.openBoardMenu': (ctx, e: { x: number; y: number; date: string; column: string }) => ({
      ...ctx,
      boardContextMenu: { x: e.x, y: e.y, date: e.date, column: e.column },
      taskContextMenu: null,
      assigneePicker: null,
      columnContextMenu: null,
    }),
    'popup.openTaskMenu': (ctx, e: { taskId: string; x: number; y: number; dayOffset: number }) => ({
      ...ctx,
      boardContextMenu: null,
      taskContextMenu: { taskId: e.taskId, x: e.x, y: e.y, dayOffset: e.dayOffset },
      assigneePicker: null,
      columnContextMenu: null,
    }),
    'popup.openAssigneePicker': (ctx, e: { taskId: string; x: number; y: number }) => ({
      ...ctx,
      boardContextMenu: null,
      taskContextMenu: null,
      assigneePicker: { taskId: e.taskId, x: e.x, y: e.y },
      columnContextMenu: null,
    }),
    'popup.openColumnMenu': (ctx, e: { x: number; y: number; column: string }) => ({
      ...ctx,
      boardContextMenu: null,
      taskContextMenu: null,
      assigneePicker: null,
      columnContextMenu: { x: e.x, y: e.y, column: e.column },
    }),
    'popup.closeBoardMenu': (ctx) => ({ ...ctx, boardContextMenu: null }),
    'popup.closeTaskMenu': (ctx) => ({ ...ctx, taskContextMenu: null }),
    'popup.closeAssigneePicker': (ctx) => ({ ...ctx, assigneePicker: null }),
    'popup.closeColumnMenu': (ctx) => ({ ...ctx, columnContextMenu: null }),
    'popup.requestAddTask': (ctx, e: { column: string; date: string }) => ({ ...ctx, addTaskRequest: { column: e.column, date: e.date } }),
    'popup.clearAddTaskRequest': (ctx) => ({ ...ctx, addTaskRequest: null }),
    'popup.requestEditColumn': (ctx, e: { column: string; x: number; y: number }) => ({ ...ctx, editColumnRequest: { column: e.column, x: e.x, y: e.y } }),
    'popup.clearEditColumnRequest': (ctx) => ({ ...ctx, editColumnRequest: null }),
    'popup.requestDeleteColumn': (ctx, e: { column: string }) => ({ ...ctx, deleteColumnRequest: { column: e.column } }),
    'popup.clearDeleteColumnRequest': (ctx) => ({ ...ctx, deleteColumnRequest: null }),
    'popup.requestTaskPool': (ctx, e: { column?: string }) => ({ ...ctx, taskPoolRequest: { column: e.column } }),
    'popup.clearTaskPoolRequest': (ctx) => ({ ...ctx, taskPoolRequest: null }),
    'popup.requestEditTask': (ctx, e: { taskId: string }) => ({ ...ctx, editTaskRequest: { taskId: e.taskId } }),
    'popup.clearEditTaskRequest': (ctx) => ({ ...ctx, editTaskRequest: null }),
    'popup.closeAll': () => ({ boardContextMenu: null, taskContextMenu: null, assigneePicker: null, columnContextMenu: null, addTaskRequest: null, editColumnRequest: null, deleteColumnRequest: null, taskPoolRequest: null, editTaskRequest: null }),
  },
});
